<div
	*transloco="let t"
	class="bg-white rounded-lg shadow-lg flex flex-col overflow-hidden border border-black/10"
	style="max-height: 440px"
	(mouseenter)="onPanelEnter()"
	(mouseleave)="onPanelLeave()">
	<div class="text-xs font-semibold text-black/50 tracking-wider [font-variant:small-caps] px-3.5 pt-2.5 pb-1.5 border-b border-black/10">
		{{ t('tenantunitDetailsCards.searchTenantUnit') }}
	</div>
	<div class="overflow-y-auto">
		@for (unit of units; track unit.id) {
			<button
				class="unit-row flex items-start gap-3 w-full px-3.5 py-2 border-none cursor-pointer text-left transition-all duration-100 border-b border-b-black/10"
				[class.unit-row--active]="unit.id === activeId"
				type="button"
				(click)="select(unit)">
				<span class="shrink-0 w-[52px] text-xs font-semibold pt-0.5" style="color: rgba(var(--color-primary), 1)">
					{{ unit.number }}/{{ unit.subNumber }}
				</span>
				<span class="flex flex-col flex-1 min-w-0">
					@if (!displayInfoMap.get(unit.id).isVacancy) {
						<span class="text-sm font-medium text-black truncate">{{ displayInfoMap.get(unit.id).primaryName }}</span>
						<span class="text-[0.7rem] text-black/40 truncate">{{ displayInfoMap.get(unit.id).primaryRoleLabel }}</span>
					} @else {
						<span class="text-sm text-black/40 italic">{{ displayInfoMap.get(unit.id).primaryName }}</span>
					}
					@for (sub of displayInfoMap.get(unit.id).subRoles; track sub.label) {
						<span class="text-xs text-gray-500 truncate">{{ sub.label }}: {{ sub.name }}</span>
					}
				</span>
			</button>
		} @empty {
			<div class="py-4 px-3.5 text-xs text-black/40 text-center">{{ t('common.noEntries') }}</div>
		}
	</div>
</div>
